import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';
import { useTheme } from './providers/ThemeProvider';
export const Footer = () => {
  const {
    currentUser,
    userType
  } = useAuth();
  const {
    theme
  } = useTheme();
  const isDark = theme === 'dark';
  const isLoggedIn = currentUser !== null;
  // Hide footer on all authenticated pages — only show on public/landing pages
  if (isLoggedIn) return null;
  return <footer className={`${isDark ? 'bg-navy-900 border-white/10' : 'bg-gray-50 border-gray-200'} border-t py-12`} data-id="element-1445">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1446">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-9 md:gap-8" data-id="element-1447">
          <div data-id="element-1448">
            <h3 className={`${isDark ? 'text-white' : 'text-gray-900'} font-semibold mb-4`} data-id="element-1449">
              Company
            </h3>
            <ul className="space-y-2" data-id="element-1450">
              <li data-id="element-1451">
                <Link to="/about" className={`${isDark ? 'text-gray-400 hover:text-white' : 'text-gray-600 hover:text-gray-900'} transition-colors`} data-id="element-1452">
                  About Us
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-1453">
            <h3 className={`text-sm font-semibold ${isDark ? 'text-gray-300' : 'text-gray-700'} uppercase tracking-wider`} data-id="element-1454">
              Resources
            </h3>
            <ul className="mt-4 space-y-2" data-id="element-1455">
              <li data-id="element-1456">
                <Link to="/blog" className={`${isDark ? 'text-gray-400 hover:text-white' : 'text-gray-600 hover:text-gray-900'} transition-colors`} data-id="element-1457">
                  Blog
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-1458">
            <h3 className={`text-sm font-semibold ${isDark ? 'text-gray-300' : 'text-gray-700'} uppercase tracking-wider`} data-id="element-1459">
              Legal
            </h3>
            <ul className="mt-4 space-y-2" data-id="element-1460">
              <li data-id="element-1461">
                <Link to="/privacy-policy" className={`${isDark ? 'text-gray-400 hover:text-white' : 'text-gray-600 hover:text-gray-900'} transition-colors`} data-id="element-1462">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-1463">
                <Link to="/terms-of-service" className={`${isDark ? 'text-gray-400 hover:text-white' : 'text-gray-600 hover:text-gray-900'} transition-colors`} data-id="element-1464">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-1465">
                <Link to="/cookie-policy" className={`${isDark ? 'text-gray-400 hover:text-white' : 'text-gray-600 hover:text-gray-900'} transition-colors`} data-id="element-1466">
                  Cookie Policy
                </Link>
              </li>
              <li data-id="element-1467">
                <Link to="/refund-policy" className={`${isDark ? 'text-gray-400 hover:text-white' : 'text-gray-600 hover:text-gray-900'} transition-colors`} data-id="element-1468">
                  Refund Policy
                </Link>
              </li>
            </ul>
          </div>
          <div id="contact" data-id="element-1469">
            <h3 className={`text-sm font-semibold ${isDark ? 'text-gray-300' : 'text-gray-700'} uppercase tracking-wider`} data-id="element-1470">
              Contact Us
            </h3>
            <ul className="mt-4 space-y-2" data-id="element-1471">
              <li className={`${isDark ? 'text-gray-400' : 'text-gray-600'}`} data-id="element-1472">
                support@maestroconnect.com
              </li>
            </ul>
          </div>
        </div>
        <div className={`mt-12 pt-8 border-t ${isDark ? 'border-white/10' : 'border-gray-200'} flex flex-col md:flex-row justify-between items-center`} data-id="element-1473">
          <p className={`${isDark ? 'text-gray-400' : 'text-gray-600'} text-sm`} data-id="element-1474">
            &copy; {new Date().getFullYear()} MaestroConnect. All rights
            reserved.
          </p>
          <div className="mt-4 md:mt-0 flex space-x-6" data-id="element-1475">
            <a href="https://www.instagram.com/maestro.connect" target="_blank" rel="noopener noreferrer" className={`${isDark ? 'text-gray-400 hover:text-white' : 'text-gray-600 hover:text-gray-900'} transition-colors`} data-id="element-1476">
              <span className="sr-only" data-id="element-1477">Instagram</span>
              <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-1478">
                <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" data-id="element-1479" />
              </svg>
            </a>
            <a href="https://www.youtube.com/@MaestroConnect" target="_blank" rel="noopener noreferrer" className={`${isDark ? 'text-gray-400 hover:text-white' : 'text-gray-600 hover:text-gray-900'} transition-colors`} data-id="element-1480">
              <span className="sr-only" data-id="element-1481">YouTube</span>
              <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-1482">
                <path fillRule="evenodd" d="M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z" clipRule="evenodd" data-id="element-1483" />
              </svg>
            </a>
            <a href="https://x.com/MaestroConnectX" target="_blank" rel="noopener noreferrer" className={`${isDark ? 'text-gray-400 hover:text-white' : 'text-gray-600 hover:text-gray-900'} transition-colors`} data-id="element-1484">
              <span className="sr-only" data-id="element-1485">Twitter</span>
              <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-1486">
                <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-1487" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>;
};